import React, { useEffect, useState } from "react";
import { Avatar } from "@/components/atoms/avatar";
import { Label } from "@/components/atoms/texts/label";
import { Button } from "@/components/molecules/buttons/button";
import { Sheet, SheetTrigger, SheetContent, SheetHeader, SheetSlot, SheetFooter, SheetClose } from "@/components/templates/sheet";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/molecules/table";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogFooter,
    DialogClose,
} from "@/components/ui/dialog";

import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import Tooltip from "@mui/material/Tooltip";

import { Toaster } from "@/components/organisms/feedback/toaster"

import { Separator } from '@/components/atoms/divider/separatorShadcn';
import DataDeletion from '@/components/macro-organisms/panels/panels-admin/DataDeletion';
import Copy from '@/components/atoms/Copy';

import NewCooptationPanel from '@/components/macro-organisms/panels/panels-admin/newCooptation/NewCooptationPanel';
import useInformationData from "@/hooks/admin-hooks/useInformationData";
import { useNavigate, useParams } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/organisms/forms/select";
import { useToast } from "@/components/organisms/feedback/use-toast"
import useUpdateUser from "@/services/mutation/admin-mutations/useUpdateUserl"; //IMPORT MUTATION
import {useUpdateConsultantProfile} from "@/services/mutation/admin-mutations/useUpdateConsultantProfile";
import useAddRetributionModel from "@/services/mutation/admin-mutations/useAddRetributionModel";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import EditInformationData from "@/components/organisms/forms/editInformationData";
import { useAuthContext } from '@/context/AuthContext';
import { format } from "date-fns";

// import useInformationTab from './UseNewCooptation'

export default function InformationTab() {
    let DEV_MODE = false;
    let DISCOUNT_GAP = 20;
    let DEFAULT_CURRENCY = "€";
    const { id } = useParams();
    const { getUser, informationData: dataUser, userError, profilesError, modelsError: retributionErrors, userLoading, profilesLoading, modelsLoading: retributionLoading, refetchUserInformation } = useInformationData(id);
    const [informationData, setInformationData] = useState({});
    // var newUuidRetribution;
    // console.log("informationData = ", informationData);
    const [openRGPD, setOpenRGPD] = React.useState(false);
    const [dialogIsOpen, setDialogIsOpen] = useState("");


    const [selectedRetribution, setSelectedRetribution] = useState();
    const [selectedProfile, setSelectedProfile] = useState();
    const [formatedRetribution, setFormatedRetribution] = useState();
    const { toast } = useToast();
    const { isBrowsingAllowedTo, hasPrivileges } = useAuthContext();

    const { setRetribution } = useUpdateUser(); //IMPORT MUTATION
    const { addRetributionModel } = useAddRetributionModel(); //IMPORT MUTATION
    const { setConsultantProfile } = useUpdateConsultantProfile(); //IMPORT MUTATION
    const navigate = useNavigate();

    const [selectedIBAN, setSelectedIBAN] = useState();
    const [selectedBIC, setSelectedBIC] = useState();
    const [selectedAddress, setSelectedAddress] = useState();
    const [selectedEmail, setSelectedEmail] = useState();
    const [selectedFiduciaryId, setSelectedFiduciaryId] = useState();
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState();
    const [selectedLeaveDate, setSelectedLeaveDate] = useState();

    // Ajout des états pour les nouveaux champs éditables
    const [selectedCommissionAmount, setSelectedCommissionAmount] = useState();
    const [selectedDailyCommissionAmount, setSelectedDailyCommissionAmount] = useState();
    const [selectedDiscountAmount, setSelectedDiscountAmount] = useState();
    const [selectedDailyRate, setSelectedDailyRate] = useState();

    useEffect(() => {
        console.log("useEffect informationData data change is now : ", dataUser);
        if (dataUser) {
            // Faire une copie des données et trier `cooptantFor` si nécessaire
            const sortedData = {
                ...dataUser,
                cooptantFor: dataUser.cooptantFor
                    ? [...dataUser.cooptantFor].sort((a, b) => {
                        const dateA = new Date(a.startDate);
                        const dateB = new Date(b.startDate);

                        // Vérifie si les dates sont valides
                        if (isNaN(dateA) || isNaN(dateB)) {
                            console.error('Invalid date detected', a.startDate, b.startDate);
                            return 0; // Si la date n'est pas valide, ne pas changer l'ordre
                        }

                        return dateA - dateB;
                    })
                    : []
            };

            // Assigner les données triées à informationData
            setInformationData(sortedData);
        }
    }, [dataUser]);


    useEffect(() => {
        informationData && informationData?.retributionModel && setFormatedRetribution(informationData?.retributionModel?.upToFiveConsultants + "/" + informationData?.retributionModel?.upToTenConsultants + "/" + informationData?.retributionModel?.moreThanTenConsultants)
        informationData && informationData?.consultantProfile && setSelectedProfile(informationData?.consultantProfile?.uuid)
        // console.log("debug informationData : ", informationData);

    }, [informationData])

    // useEffect(() => {
    //     console.log("uuseeffect newuuidretribution");
    //     informationData && informationData?.uuid && newUuidRetribution && sendData(informationData?.uuid, newUuidRetribution);
    // }, [newUuidRetribution])

    const [isInputValid, setIsInputValid] = useState(true); // État pour suivre la validité de l'input

    const [inputValue, setInputValue] = useState("");

    const validateInput = (value) => {
        const regex = /^\d{1,2}\/\d{1,2}\/\d{1,2}$/; // Expression régulière pour le format 00/00/00
        return regex.test(value);
    };

    const handleInputBlur = (e) => {
        if (!e.target.value) {
            return;
        }
        setSelectedRetribution(e.target.value);
        const isValid = validateInput(e.target.value);
        setIsInputValid(isValid); // Met à jour l'état de validité de l'input
        if (isValid) {
            setInputValue(e.target.value); // Met à jour la valeur sélectionnée si l'input est valide
        }
    };

    const callUpdateRetibutionModel = (selectedRetribution) => { //IMPORT MUTATION

        const sendData = async (uuid_, selectedRetribution_) => {
            const { data, error } = await setRetribution(uuid_, selectedRetribution_);
            if (error) {
                toast({
                    variant: "error",
                    title: "error.requestFailed",
                    duration: 8000,
                    message: error
                })
                console.error("Error updating data:", error);
            } else {
                toast({
                    variant: "success",
                    title: "success.changesSaved",
                    duration: 1500,
                })
                // console.log("retributionModel updated data:", data);
                setInformationData((prevData) => ({
                    ...prevData,
                    retributionModel: data.retributionModel
                }));
            }
            data && refetchUserInformation(id);
            getUser(id);
        };


        const sendDataAddRetributionModel = async () => {
            const [upToFiveConsultants, upToTenConsultants, moreThanTenConsultants] = selectedRetribution.split('/');
            const { data: dataAddRetribution, error: errorAddRetribution } = await addRetributionModel(upToFiveConsultants, upToTenConsultants, moreThanTenConsultants, informationData?.company.uuid);
            if (errorAddRetribution) {
                toast({
                    variant: "error",
                    title: "error.requestFailed",
                    duration: 8000,
                    message: errorAddRetribution
                })
                console.error("Error updating data:", errorAddRetribution);
            } else {
                toast({
                    variant: "success",
                    title: "success.changesSaved",
                    duration: 1500,
                })
                // console.log("Cooptations updated data:", dataAddRetribution, errorAddRetribution);
                // console.log("BEFORE SEND DATA:", informationData?.uuid, dataAddRetribution.uuid);

                sendData(informationData?.uuid, dataAddRetribution.uuid)
                setInputValue();
                setSelectedRetribution();
            }
            dataAddRetribution && refetchUserInformation(id);
            getUser(id);
        };

        if (inputValue) {
            //creer un nouveau modele
            (isInputValid) && sendDataAddRetributionModel();
        } else {
            sendData(informationData?.uuid, selectedRetribution);
        }
    }

    const callUpdateConsultantProfile = (selectedProfile) => {

        const sendData = async () => {
            const { data, error } = await setConsultantProfile(informationData?.uuid, selectedProfile);
            if (error) {
                toast({
                    variant: "error",
                    title: "error.requestFailed",
                    duration: 8000,
                    message: error
                })
                console.error("Error updating data:", error);
            } else {
                toast({
                    variant: "success",
                    title: "success.changesSaved",
                    duration: 1500,
                })
                // console.log("Cooptations updated data:", data);
                setInformationData((prevData) => ({
                    ...prevData,
                    consultantProfile: data.consultantProfile,
                    // Réinitialiser les commissions pour afficher "non renseigné" jusqu'au refresh
                    consultantInvoiceDefaults: {
                        ...prevData.consultantInvoiceDefaults,
                        monthlyCommissionEur: undefined,
                        dailyCommissionEur: undefined
                    }
                }));
            }
            console.log("Profil updated data:", data, data?.consultantProfile?.uuid, informationData?.consultantProfile?.cooptationType);
            (data?.consultantProfile?.uuid) && refetchUserInformation(id);
            getUser(id);
        };
        sendData();
    }



    const renderCooptingRows = () => {
        return informationData?.cooptantFor?.map((cooptingItem, index) => (
            <TableRow key={index}>
                <TableCell className="p-1 text-center">{cooptingItem?.coopted?.firstname + " " + cooptingItem?.coopted?.lastname}</TableCell>
                {informationData?.consultantProfile?.cooptationType === 'PERCENTAGE_RETRIBUTION' && <TableCell className="p-1 text-center">
                    {informationData?.retributionModel
                        ? index < 5
                            ?
                            <Label >{informationData?.retributionModel?.upToFiveConsultants} %</Label>
                            : index < 10 ?
                                <Label >{informationData?.retributionModel?.upToTenConsultants} %</Label>
                                :
                                <Label >{informationData?.retributionModel?.moreThanTenConsultants} %</Label>
                        : <Label color="gray400" message="error.unfilled" />
                    }

                </TableCell>}
                {informationData?.consultantProfile?.cooptationType === 'COMMISSION_DISCOUNT' && <TableCell className="p-1 text-center">
                    {index < 5 ? <Label >{DISCOUNT_GAP} %</Label> : <Label >0 %</Label>}
                </TableCell>}
                <TableCell className="p-1 text-center align-center">
                    <Label > {cooptingItem?.percentage} %</Label>{" "}
                </TableCell>
                <TableCell className="p-1 text-center">
                    {cooptingItem?.monthsDuration === "∞" ? (
                        cooptingItem?.monthsDuration
                    ) : (
                        <>
                            <Label >{cooptingItem?.monthsDuration == 0 ? "∞" : cooptingItem?.monthsDuration}</Label>
                            <Label size="small" color="gray400"> ({cooptingItem?.startDate})</Label>
                        </>
                    )}
                </TableCell>

            </TableRow>
        ));
    };

    if ((!informationData && !userLoading) || userError) {
        return (<>
            {userError && <PrintErrorMessage error={userError} />}
            {!userError && <PrintErrorMessage label='error.errorFetchData' />}
        </>);
    }

    const categoryBlockClass = "flex flex-col justify-start gap-secondDegree  pl-secondDegree py-firstDegree border-l  border-greyStrong bg-[#FFFFFF50] rounded-r-sm backdrop-blur-md";

    return (
        <div className="flex gap-thirdDegree justify-center w-full ">
            {userLoading && !informationData && <span className="loader my-4"></span>}
            <Toaster />
            {informationData && <Avatar
                fallback={informationData?.firstname + " " + informationData?.lastname}
                size="medium"
                className="shrink-0 grow-0 "
            />}
            {informationData && <div className="flex flex-col gap-secondDegree grow w-full">
                <div className="flex justify-between  grow">
                    <Label
                        size="h3"
                        fontWeight="bold"
                        message="consultants.dashboard.tabs.information"
                    />

                    {hasPrivileges("ADMIN_COOPTATIONS") && <NewCooptationPanel onSaved={() => refetchUserInformation()} />}

                </div>
                <div className="flex flex-col xl:flex-row gap-secondDegree">
                    <div className="flex flex-col grow justify-start gap-secondDegree min-w-[400px]">

                        {/* --- IDENTITÉ --- */}
                        <Label size="h4" color='primary' className="mt-2 mb-1 " fontWeight="bold" message="consultants.informations.section.identity" />
                        <div className={categoryBlockClass}>
                            {/* FiduciaryId */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.fiduciaryId" />
                                <aside className="flex gap-firstDegree items-center group">
                                    {informationData?.fiduciaryId ? <Label className="group">{informationData?.fiduciaryId}  <Copy value={informationData?.fiduciaryId} /></Label> : <Label color="gray400" message="error.unfilled" />}
                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedFiduciaryId}
                                        setInputValue={setSelectedFiduciaryId}
                                        title="consultants.informations.fiduciaryId"
                                        actualLabel="consultants.informations.actualFiduciaryId"
                                        selectLabel="consultants.informations.selectFiduciaryId"
                                        data={informationData?.fiduciaryId}
                                        type="fiduciaryId"
                                        typeForInput="number"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                    />}
                                </aside>

                            </div>
                            {/* Email personnel */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.email" />
                                <aside className="flex gap-firstDegree items-center group">
                                    {informationData?.personalEmail ? <Label className="group">{informationData?.personalEmail}  <Copy value={informationData?.personalEmail} /></Label> : <Label color="gray400" message="error.unfilled" />}
                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedEmail}
                                        setInputValue={setSelectedEmail}
                                        title="consultants.informations.email"
                                        actualLabel="consultants.informations.actualEmail"
                                        selectLabel="consultants.informations.selectEmail"
                                        data={informationData?.personalEmail}
                                        type="personalEmail"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                    />}
                                </aside>

                            </div>

                            {/* proEmail */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.proEmail" />
                                {informationData?.email ? <Label className="group">{informationData?.email}  <Copy value={informationData?.email} /></Label> : <Label color="gray400" message="error.unfilled" />}
                            </div>

                            {/* phoneNumber */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.phoneNumber" />
                                <aside className="flex gap-firstDegree items-center group">

                                    {informationData?.phoneNumber ? <Label className="group">{informationData?.phoneNumber}  <Copy value={informationData?.phoneNumber} /></Label> : <Label color="gray400" message="error.unfilled" />}
                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedPhoneNumber}
                                        setInputValue={setSelectedPhoneNumber}
                                        title="consultants.informations.phoneNumber"
                                        actualLabel="consultants.informations.actualPhoneNumber"
                                        selectLabel="consultants.informations.selectPhoneNumber"
                                        data={informationData?.phoneNumber}
                                        type="phoneNumber"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}

                                    />}
                                </aside>
                            </div>

                            {/* Address */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.address" />
                                <aside className="flex gap-firstDegree items-center group">

                                    {informationData?.addressLine1 || informationData?.addressLine2 || informationData?.zipCode || informationData?.city || informationData?.countryCode ? <Label className="group ">
                                        {informationData?.addressLine1},  {informationData?.addressLine2}
                                        <br />
                                        {informationData?.zipCode},  {informationData?.city},  {informationData?.countryCode} <Copy value={informationData?.addressLine1 + ", " + informationData?.addressLine2 + ", " + informationData?.zipCode + ", " + informationData?.city + ", " + informationData?.countryCode} />
                                    </Label> : <Label color="gray400" message="error.unfilled" />}
                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedAddress}
                                        setInputValue={setSelectedAddress}
                                        title="consultants.informations.address"
                                        actualLabel="consultants.informations.actualAddress"
                                        selectLabel="consultants.informations.selectAddress"
                                        data={informationData?.addressLine1 + ", " + informationData?.addressLine2 + ", " + informationData?.zipCode + ", " + informationData?.city + ", " + informationData?.countryCode}
                                        type="address"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid} />}
                                </aside>
                            </div>

                        </div>


                        {/* --- BANCAIRE --- */}
                        <Label size="h4" color='primary' className="mt-4 mb-1" fontWeight="bold" message="consultants.informations.section.bank" />
                        <div className={categoryBlockClass}>
                            {/* IBAN */}
                            {hasPrivileges("ADMIN_USER_INFO_FULL") && <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.iban" />
                                <aside className="flex gap-firstDegree items-center group">

                                    {informationData?.iban ? <Label className="group ">{informationData?.iban}  <Copy value={informationData?.iban} /></Label> : <Label color="gray400" message="error.unfilled" />}
                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedIBAN}
                                        setInputValue={setSelectedIBAN}
                                        title="consultants.informations.iban"
                                        actualLabel="consultants.informations.actualIBAN"
                                        selectLabel="consultants.informations.selectIBAN"
                                        data={informationData?.iban}
                                        type="iban"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                    />}
                                </aside>
                            </div>}

                            {/* BIC */}
                            {hasPrivileges("ADMIN_USER_INFO_FULL") && <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.bic" />
                                <aside className="flex gap-firstDegree items-center group">

                                    {informationData?.bicCode ? <Label className="group ">{informationData?.bicCode}  <Copy value={informationData?.bicCode} /></Label> : <Label color="gray400" message="error.unfilled" />}
                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedBIC}
                                        setInputValue={setSelectedBIC}
                                        title="consultants.informations.bic"
                                        actualLabel="consultants.informations.actualBIC"
                                        selectLabel="consultants.informations.selectBIC"
                                        data={informationData?.bicCode}
                                        type="bicCode"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                    />}
                                </aside>

                            </div>}
                        </div>
                        {/* --- EMPLOI --- */}
                        <Label size="h4" color='primary' className="mt-4 mb-1" fontWeight="bold" message="consultants.informations.section.work" />
                        <div className={categoryBlockClass}>
                            {/* Seniority */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.seniority" />
                                {informationData?.entryDate ? (
                                    <Label className="group">
                                        {format(new Date(informationData.entryDate), "dd/MM/yyyy")} <Copy value={format(new Date(informationData.entryDate), "dd/MM/yyyy")} />
                                    </Label>
                                ) : (
                                    <Label color="gray400" message="error.unfilled" />
                                )}
                            </div>

                            {/* Date de sortie de l'entreprise */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.leaveDate" />
                                <aside className="flex gap-firstDegree items-center group">
                                    {informationData?.leaveDate ? (
                                        <Label className="">
                                            {format(new Date(informationData.leaveDate), "dd/MM/yyyy")}  <Copy value={format(new Date(informationData.leaveDate), "dd/MM/yyyy")} />
                                        </Label>
                                    ) : (
                                        <Label color="gray400" message="error.unfilled" />
                                    )}
                                    {<EditInformationData
                                        inputValue={selectedLeaveDate}
                                        setInputValue={setSelectedLeaveDate}
                                        title="consultants.informations.leaveDate"
                                        actualLabel="consultants.informations.actualLeaveDate"
                                        selectLabel="consultants.informations.selectLeaveDate"
                                        data={informationData?.leaveDate}
                                        type="leaveDate"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                        typeForInput="date"
                                    />}
                                </aside>
                            </div>
                        </div>
                        {/* --- DONNÉES PERSONNELLES --- */}
                        <Label size="h4" color='primary' className="mt-4 mb-1" fontWeight="bold" message="consultants.informations.section.privacy" />
                        <div className={categoryBlockClass}>
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.dataPrivacy" />
                                <Sheet open={openRGPD} onOpenChange={setOpenRGPD}>
                                    <SheetTrigger asChild className="w-min">
                                        <Button text="global.panelOpening.showMore" className="w-min" style="dressedGhost" />
                                    </SheetTrigger>
                                    <SheetContent >
                                        <SheetHeader
                                            title={"consultants.informations.dataDeletionInfo.panel.title"}
                                        />
                                        <SheetSlot className=" flex ">
                                            <DataDeletion />
                                        </SheetSlot>
                                        {/* <SheetFooter
                                        buttonOutlineText={"global.actions.cancel"}
                                        buttonDressedText={"global.actions.request"}
                                        warning={"consultants.informations.dataDeletionInfo.warning.dataDeletion"}
                                        onClickOutline={() => setOpenRGPD(false)}
                                        onClickDressed={(checkboxIsChecked) => { console.log(informationData?.uuid, 'user ask data deletion, consent done  : ', checkboxIsChecked) }}
                                    /> */}
                                    </SheetContent>
                                </Sheet>
                            </div>
                        </div>

                    </div>
                    {/* <Separator orientation="vertical" /> */}
                    <div className="flex flex-col grow-3 justify-start gap-secondDegree ">

                        {/* --- PROFIL & RÉMUNÉRATION --- */}
                        <Label size="h4" color='primary' className="mt-4 mb-1" fontWeight="bold" message="consultants.informations.section.compensation" />
                        <div className={categoryBlockClass}>
                            {/* Profile */}
                            <div className="flex flex-col gap-firstDegree group">
                                <Label
                                    fontWeight="bold"
                                    message="consultants.informations.profile"
                                />
                                <span className="flex items-center gap-firstDegree">
                                    {informationData?.consultantProfile ? (
                                        <Label className="group h-full">
                                            {informationData?.consultantProfile.name} <Copy value={informationData?.consultantProfile?.name} />
                                        </Label>
                                    ) : (
                                        <Label color="gray400" message="error.unfilled" />
                                    )}
                                    {hasPrivileges("ADMIN_USERS") && (
                                        <EditInformationData
                                            inputValue={selectedProfile}
                                            setInputValue={setSelectedProfile}
                                            title="consultants.informations.profile"
                                            actualLabel="consultants.informations.actualProfil"
                                            selectLabel="consultants.informations.selectProfile"
                                            data={informationData?.consultantProfile?.name}
                                            type="consultantProfile"
                                            setInformationData={setInformationData}
                                            consultantUuid={informationData?.uuid}
                                            allProfiles={informationData?.allConsultantProfiles}
                                            profilesLoading={profilesLoading}
                                            profilesError={profilesError}
                                        />
                                    )}
                                </span>
                            </div>

                            {/* Daily rate */}
                            <div className="flex flex-col gap-firstDegree group">
                                <Label fontWeight="bold" message="consultants.informations.dailyRateConsultantDefault" />
                                <span className="flex items-center gap-firstDegree">
                                    {informationData?.consultantInvoiceDefaults?.dailyRateConsultantEur
                                        ?
                                        <Label>{informationData?.consultantInvoiceDefaults?.dailyRateConsultantEur} {DEFAULT_CURRENCY}</Label>
                                        :
                                        <Label color="gray400" message="error.unfilled" />
                                    }
                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedDailyRate}
                                        setInputValue={setSelectedDailyRate}
                                        title="consultants.informations.dailyRateConsultant"
                                        actualLabel="consultants.informations.actualDailyRateConsultant"
                                        selectLabel="consultants.informations.selectDailyRateConsultant"
                                        data={informationData?.consultantInvoiceDefaults?.dailyRateConsultantEur}
                                        type="dailyRateConsultantEur"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                        typeForInput="number"
                                        unit="€"

                                    />}
                                </span>
                            </div>

                            {/* Commission (mensuelle + journalière) */}
                            {hasPrivileges("ADMIN_COOPTATIONS") && <div className="flex flex-col gap-firstDegree group">
                                <Label fontWeight="bold" message="consultants.statement.billsDetails.commission" />
                                <span className="flex items-center gap-firstDegree">
                                    {informationData?.consultantInvoiceDefaults?.manualCommission === true ? (
                                        <Label>
                                            {informationData?.consultantInvoiceDefaults?.monthlyCommissionEur}€/mois
                                            {(informationData?.consultantInvoiceDefaults?.dailyCommissionEur ?? 0) > 0
                                                && ` et ${informationData?.consultantInvoiceDefaults?.dailyCommissionEur}€/jour`
                                            }
                                        </Label>
                                    ) : (
                                        <Label message="consultants.statement.billsDetails.autoCommission" />
                                    )}

                                    {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedCommissionAmount}
                                        setInputValue={setSelectedCommissionAmount}
                                        secondaryInputValue={selectedDailyCommissionAmount}
                                        setSecondaryInputValue={setSelectedDailyCommissionAmount}
                                        title="consultants.informations.commissionAmount"
                                        actualLabel="consultants.informations.actualCommissionAmount"
                                        selectLabel="consultants.informations.selectCommissionAmount"
                                        data={informationData?.consultantInvoiceDefaults?.monthlyCommissionEur}
                                        secondaryData={informationData?.consultantInvoiceDefaults?.dailyCommissionEur}
                                        exceptionnalData={informationData?.consultantInvoiceDefaults?.manualCommission}
                                        type="commissionAmounts"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                        typeForInput="number"
                                        unit="€"
                                        component={(!informationData?.consultantInvoiceDefaults?.monthlyCommissionEur) && <span><Label message="consultants.informations.lastStatementCommission"></Label>&#x20;&#x3A;&#x20;<Label>{informationData?.latestStatementMonth?.commission}€</Label></span>}
                                    />}
                                </span>
                            </div>}

                            {/* Discount sur la commission */}
                            {hasPrivileges("ADMIN_COOPTATIONS") && (informationData?.consultantProfile?.cooptationType === 'COMMISSION_DISCOUNT' || DEV_MODE) && <div className="flex flex-col gap-firstDegree group">
                                <Label fontWeight="bold" message="consultants.informations.discountAmount" />
                                <span className="flex items-center gap-firstDegree">
                                    {informationData?.consultantProfile?.discountAmount
                                        ?
                                        <Label>{informationData?.consultantProfile?.discountAmount}</Label>
                                        :
                                        <Label>{(informationData?.cooptantFor?.length * DISCOUNT_GAP) <= 100 ? informationData?.cooptantFor?.length * DISCOUNT_GAP : "100"} %</Label>
                                    }
                                    {/* icone help de mui avec tootltip shadcn utilissant le label au message consultants.informations.discountAmountHelper */}
                                    {/* {hasPrivileges("ADMIN_USERS") && <EditInformationData
                                        inputValue={selectedDiscountAmount}
                                        setInputValue={setSelectedDiscountAmount}
                                        title="consultants.informations.discountAmount"
                                        actualLabel="consultants.informations.actualDiscountAmount"
                                        selectLabel="consultants.informations.selectDiscountAmount"
                                        data={(informationData?.cooptantFor?.length * DISCOUNT_GAP) <= 100 ? (informationData?.cooptantFor?.length * DISCOUNT_GAP + " %") : "100 %"}
                                        type="discountAmount"
                                        setInformationData={setInformationData}
                                        consultantUuid={informationData?.uuid}
                                        typeForInput="number"
                                    />} */}
                                    {/* manualcommision plutot que discount */}
                                </span>
                            </div>}

                        </div>

                        {/* --- COOPTATION --- */}
                        <Label size="h4" color='primary' className="mt-2 mb-1" fontWeight="bold" message="consultants.informations.section.cooptation" />
                        <div className={categoryBlockClass}>
                            {/* CooptedBy */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.cooptedBy" />
                                {informationData?.cooptedBy && informationData?.cooptedBy.length > 0 ?
                                    <>
                                        {informationData?.cooptedBy.map((item, index) => (
                                            <Label className={`group`} onClick={() => isBrowsingAllowedTo(`/consultant/` + item?.cooptant?.uuid + `/information`) && navigate(`/consultant/` + item?.cooptant?.uuid + `/information`)} key={index}>
                                                <a className={`cursor-default ${isBrowsingAllowedTo(`/consultant/` + item?.cooptant?.uuid + `/information`) && 'underline cursor-pointer'} `} onClick={(e) => { e.preventDefault() }} href={`/consultant/` + item?.cooptant?.uuid}>{item?.cooptant?.firstname + " " + item?.cooptant?.lastname}</a>  <Copy value={item?.cooptant?.firstname + " " + item?.cooptant?.lastname} />
                                            </Label>

                                        ))}
                                    </>
                                    :
                                    <Label color="gray400" message="error.unfilled" />
                                }

                            </div>

                            {/* Cooptation Type */}
                            <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.cooptationType.title" />
                                {informationData?.consultantProfile?.cooptationType ? <Label message={"consultants.informations.cooptationType." + informationData?.consultantProfile?.cooptationType}>{informationData?.consultantProfile?.cooptationType}</Label> : <Label color="gray400" message="error.unfilled" />}
                                {informationData?.consultantProfile?.cooptationType === 'NONE' && <Label color="gray400" message="consultants.informations.noCooptationsEnabled" />}
                            </div>

                            {/* Type de cooptation : Retribution en pourcentage : PERCENTAGE_RETRIBUTION*/}
                            {/* Regime */}
                            {hasPrivileges("ADMIN_COOPTATIONS") && (informationData?.consultantProfile?.cooptationType === 'PERCENTAGE_RETRIBUTION' || DEV_MODE) && <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.dashboard.newCooptation.table.regime" />
                                <aside className="flex gap-secondDegree items-center">

                                    {informationData?.retributionModel ? <Label className="group">{formatedRetribution}   <Copy value={formatedRetribution} /></Label> : <Label color="gray400" message="error.unfilled" />}
                                    {hasPrivileges("ADMIN_COOPTATIONS") && <Dialog open={dialogIsOpen} onOpenChange={setDialogIsOpen}>
                                        <DialogTrigger>
                                            <Label className="hover:cursor-pointer font-bold underline" color='primary' message="global.actions.set" />
                                        </DialogTrigger>
                                        <DialogContent>
                                            <DialogHeader>
                                                <DialogTitle><Label message="consultants.informations.retribution.title" size="h4" />{informationData?.firstname + " " + informationData?.lastname}</DialogTitle>
                                                <DialogDescription className="flex flex-col gap-4 py-4">
                                                    {informationData?.retributionModel && <span className='font-bold text-body'><Label className='font-medium' message="consultants.informations.retribution.actual" />{informationData?.retributionModel?.upToFiveConsultants + "/" + informationData?.retributionModel?.upToTenConsultants + "/" + informationData?.retributionModel?.moreThanTenConsultants}</span>}
                                                    <Label fontWeight='bold' message="consultants.informations.retribution.instruction" />
                                                    {retributionLoading && <span className="loader" />}
                                                    {retributionErrors && <PrintErrorMessage error={retributionErrors} className="col-span-5 w-full" />}
                                                    {(!retributionErrors && !retributionLoading) && <RadioGroup value={selectedRetribution || (informationData?.retributionModel && informationData?.retributionModel?.uuid)} onValueChange={setSelectedRetribution} >
                                                        {informationData?.allRetributionsModels && informationData?.allRetributionsModels.map((item, index) => (
                                                            <div className="flex items-center space-x-2" key={index}>
                                                                <RadioGroupItem value={item?.uuid} id={index} />
                                                                <Label htmlFor={item?.uuid}>{item?.upToFiveConsultants + "/" + item?.upToTenConsultants + "/" + item?.moreThanTenConsultants}</Label>

                                                            </div>
                                                        ))}
                                                        {/* {console.log("selectedRetribution : ", selectedRetribution)} */}
                                                        <div className="flex items-center space-x-2">
                                                            <RadioGroupItem value={inputValue} id="r3" />
                                                            <input
                                                                htmlFor="r3"
                                                                className={`px-2 py-1 rounded-sm border ${isInputValid ? 'border-grey' : 'border-error'}`}
                                                                onBlur={handleInputBlur}

                                                                placeholder='--/--/--' />
                                                        </div>
                                                    </RadioGroup>}
                                                    {!isInputValid && <Label className="text-error" message="error.formatRetribution" />}
                                                </DialogDescription>
                                            </DialogHeader>
                                            <DialogFooter className="sm:justify-start">
                                                <DialogClose asChild>
                                                    <Button type="button" style="ghost" text='global.actions.cancel' />
                                                </DialogClose>
                                                {(!retributionErrors && !retributionLoading) && <Button style="fill" text='global.actions.save' className="w-full" onClick={() => { callUpdateRetibutionModel(selectedRetribution); setDialogIsOpen(false) }} />}                                        </DialogFooter>
                                        </DialogContent>

                                    </Dialog>}

                                </aside>

                            </div>}

                            {/* Cooptations */}
                            {(hasPrivileges("ADMIN_COOPTATIONS") && (informationData?.consultantProfile?.cooptationType === 'PERCENTAGE_RETRIBUTION' || informationData?.consultantProfile?.cooptationType === 'COMMISSION_DISCOUNT' || DEV_MODE) && informationData?.cooptantFor && informationData?.cooptantFor?.length > 0) && <div className="flex flex-col gap-firstDegree">
                                <Label fontWeight="bold" message="consultants.informations.activeCooptation" />
                                <Table>
                                    <TableHeader>
                                        <TableRow>
                                            <TableHead className="bg-transparent w-[25%] h-auto py-firstDegree"><Label message="consultants.dashboard.newCooptation.table.name" /></TableHead>
                                            {informationData?.consultantProfile?.cooptationType === 'PERCENTAGE_RETRIBUTION' && <TableHead className="w-[25%]"><Label message="consultants.dashboard.newCooptation.table.regime" /></TableHead>}
                                            {informationData?.consultantProfile?.cooptationType === 'COMMISSION_DISCOUNT' && <TableHead className="w-[25%]"><Label message="consultants.informations.discountAmount" /></TableHead>}
                                            <TableHead className=""><Label message="consultants.dashboard.newCooptation.table.ownership" /></TableHead>
                                            <TableHead className=""><Label message="consultants.dashboard.newCooptation.table.duration" /></TableHead>
                                        </TableRow>
                                    </TableHeader>
                                    <TableBody>

                                        {informationData?.cooptantFor?.length > 0 && renderCooptingRows()}

                                    </TableBody>
                                </Table>

                            </div>}
                        </div>

                    </div>

                </div>
            </div>}
        </div >


    )

}
